import React from 'react';
interface ServiceCardProps {
  title: string;
  description: string;
  deliverables: string[];
  icon?: React.ReactNode;
}
export function ServiceCard({
  title,
  description,
  deliverables,
  icon
}: ServiceCardProps) {
  return <div className="bg-white p-8 rounded-lg shadow-md luxury-border hover:shadow-lg transition-shadow elegant-card" data-id="element-183">
      <div className="mb-4 accent-color" data-id="element-184">{icon}</div>
      <h3 className="text-xl font-bold mb-3" data-id="element-185">{title}</h3>
      <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-186">{description}</p>
      <div className="mb-4" data-id="element-187">
        <h4 className="text-sm font-semibold uppercase accent-color mb-2 elegant-subheading" data-id="element-188">
          Deliverables:
        </h4>
        <ul className="space-y-1" data-id="element-189">
          {deliverables.map((item, index) => <li key={index} className="text-gray-700" data-id="element-190">
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}